module.exports = __webpack_public_path__ + "static/media/img159.a33dfee0.jpg";